const experts = [
  { initials: "DA", name: "Dr. Ananya Reddy", specialty: "Additive Manufacturing", rate: 1500 },
  { initials: "PK", name: "Prof. Karthik Iyer", specialty: "Robotics & Mechatronics", rate: 1800 },
  { initials: "MS", name: "Meera Sundaram", specialty: "PCB & Embedded", rate: 1200 },
];

export default function ExpertConsultationStep({ formData, updateField }) {
  return (
    <div>
      <div className="space-y-4 mb-6">
        {experts.map(({ initials, name, specialty, rate }) => {
          const isSelected = formData.expert === name;
          return (
            <div
              key={name}
              className="flex items-center justify-between border border-gray-100 rounded-xl px-5 py-4"
            >
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-indigo-500 to-purple-600 text-white text-xs font-bold flex items-center justify-center">
                  {initials}
                </div>
                <div>
                  <p className="font-bold text-gray-900">{name}</p>
                  <p className="text-sm text-gray-500">
                    {specialty} · ₹{rate.toLocaleString("en-IN")}/session
                  </p>
                </div>
              </div>
              <button
                type="button"
                onClick={() => updateField("expert", isSelected ? "" : name)}
                className={`text-sm font-semibold px-5 py-2 rounded-xl border transition ${
                  isSelected
                    ? "bg-indigo-600 border-indigo-600 text-white"
                    : "border-gray-200 text-gray-700 hover:bg-gray-50"
                }`}
              >
                {isSelected ? "Selected" : "Book"}
              </button>
            </div>
          );
        })}
      </div>
      <p className="text-center text-sm text-gray-500">
        Or skip — you can add an expert later.
      </p>
    </div>
  );
}